<template>
  <section
    class="text-center container col-lg-8 col-md-9 col-sm-10 mx-auto mt-2 mb-4"
  >
    <h1 class="animate-characters">The Reaperville NFT Collection</h1>

    <h4 class="text-muted">
      This collection of colorful reapers is the first NFT collection of the
      Surviville project.
      <a target="_blank" href="https://ville.cash/"
        >Learn more about Surviville.</a
      >
    </h4>
    <div class="col-xxl-4 mx-auto mt-4 mb-4">
      <img
        src="/images/avatar/preview.gif"
        class="img-fluid rounded"
        alt="Reaperville NFTs Preview"
      />
    </div>
    <h4 class="text-muted">
      After minting some Reaperville NFTs, you can stake them
      <router-link to="/my-reapers">here</router-link>
      <!-- <a href="/my-reapers">here</a> -->
      to earn a passive income stream of Surviville coins. These coins can be
      used to permanently upgrade the level of your NFTs in order to increase
      their staking power.
    </h4>
    <h4 class="text-muted">
      In the future, more use cases will follow — such as giving your NFTs
      custom names and participating in winning opportunities.
    </h4>

    <br />
    <template v-if="nftsMinted < nftsToMintTotal">
      <h2>For {{ bchPerNft / 10 ** 18 }} {{ ETH }} you can mint 1 NFT.</h2>

      <h4 class="lead text-muted mx-auto my-3">
        <span>You can mint up to 40 NFTs per transaction. </span>
        <span>The NFTs are minted in a non-sequential, randomised order.</span>
      </h4>

      <h2 class="mx-auto my-4" id="nftsMinted">
        <span
          >{{ nftsMinted }} of {{ nftsToMintTotal }} NFTs have been
          minted.</span
        >
        <a href="#nftsMinted"
          ><i title="Reload numbers" @click="load()" class="ri-refresh-fill"></i
        ></a>
      </h2>

      <h4 class="lead text-muted mx-auto my-3">
        <span>Please select how many Reaperville NFTs you want to mint.</span>
      </h4>

      <div class="mb-3 mx-auto">
        <div class="input-group mx-auto">
          <div class="input-group-prepend mx-auto">
            <button
              v-for="_nfts in [1, 5, 10, 15, 20, 25, 30, 40]"
              :key="_nfts"
              class="btn btn-std"
              type="button"
              @click="setNftsToMint(_nfts)"
            >
              {{ _nfts }}
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3 mx-auto">
        <div class="input-group mx-auto">
          <div class="input-group-prepend mx-auto">
            <button
              class="btn btn-std"
              :disabled="nftsToMint <= 1"
              @click="changeNftsToMint(-1)"
            >
              -
            </button>

            <div class="col-lg-8 col-md-8 col-sm-8 mx-auto">
              <input
                id="tokensToBuy"
                type="number"
                min="1"
                :max="maxNftsPerTx"
                class="form-control mx-auto"
                @change="changeNftsToMint(0)"
                v-model="nftsToMint"
              />
            </div>

            <button
              class="btn btn-std"
              :disabled="nftsToMint >= maxNftsPerTx"
              @click="changeNftsToMint(1)"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <span class="row-lg-12">
        <span class="column">
          <h4 v-if="nftsToMint > 1">
            Mint {{ nftsToMint }} Reaperville NFTs for:
          </h4>
          <h4 v-else>Mint 1 Reaperville NFT for:</h4>
          <div class="col-lg-6 col-md-8 mx-auto">
            <button
              id="buyButtonBch"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="mintPaused || bchPerNft <= 0"
              @click="mintNFTsWithBCH"
            >
              {{ Math.round((nftsToMint * bchPerNft) / 10 ** 12) / 10 ** 6 }}
              {{ ETH }}
            </button>
            <!-- &nbsp;
            <button
              id="buyButtonWom"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="mintPaused || powTokenPriceWom <= 0"
              @click="buyPowWithToken('WoM')"
            >
              {{
                Math.round((nftsToMint * powTokenPriceWom) / 10 ** 12) / 10 ** 6
              }}
              WoM
            </button>
            &nbsp;
            <button
              id="buyButtonFlexUsd"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="mintPaused || powTokenPriceFlexUsd <= 0"
              @click="buyPowWithToken('flexUSD')"
            >
              {{
                Math.round((nftsToMint * powTokenPriceFlexUsd) / 10 ** 12) /
                10 ** 6
              }}
              flexUSD
            </button> -->
          </div>
        </span>
      </span>
    </template>
    <template v-else>
      <h2 class="mt-4">
        All Reaperville NFTs have been minted. Visit
        <a
          :href="'https://oasis.cash/collection/' + mintContractAddress"
          target="_blank"
          >Oasis.cash</a
        >
        to check if there are some for sale!
      </h2>
    </template>

    <br />

    <h3 class="mt-4">
      <span
        >Your Balance: {{ Math.round(stakersBchBalance / 10 ** 15) / 10 ** 3 }}
        {{ ETH }}
        <!-- {{ Math.round(stakersWomBalance / 10 ** 15) / 10 ** 3 }} WoM,
              {{ Math.round(stakersFlexUsdBalance / 10 ** 15) / 10 ** 3 }}
              flexUSD -->
      </span>
    </h3>

    <h3>You hold {{ nftsOwned }} Reaperville NFTs in your wallet.</h3>

    <br />

    <h6 class="text-muted mt-2">
      <span
        >The gas limit is set to {{ gasLimit }} to ensure a successful mint.
        Unused gas is automatically returned to your wallet. If you lower the
        gas limit, you risk having failed transactions. If a transaction fails,
        the gas fee is lost.</span
      >
    </h6>

    <h6 class="mx-auto text-muted">
      <span>Note that transactions cannot be undone.</span>
    </h6>

    <!-- <br />
    <h1 class="fw-light"><strong>Your POW tokens</strong></h1>

    <div class="lead text-muted">
      <span>Balance: {{ stakersRewardTokenBalance }} POW </span>
    </div>
    <div
      class="lead text-muted"
      v-if="stakersRewardTokenBalance > 0 && stakersPowAllowanceForLeveling <= 0"
    >
      <span>Remember to approve the POW token for level upgrades.</span>
    </div>
    <div
      class="lead text-muted"
      v-if="stakersRewardTokenBalance > 0 && stakersPowAllowanceForLeveling > 0"
    >
      <span>You are now ready to level up some NFTs!</span>
    </div>

    <br /> 
    <div class="row py-5">
      <div>
        <h1 class="fw-light">
          <strong>POW Tokens Approval for Leveling</strong>
        </h1>

        <div class="lead text-muted">
          <span
            >Before you can upgrade the staking power of the NFTs, you have to
            approve the leveler contract as a spender of POW tokens.</span
          >
        </div>

        <div class="lead text-muted">
          <span>You only need to give your approval once.</span>
        </div>

        <div class="lead text-muted">
          <span
            >If you wish to remove your approval, you can do that here,
            too.</span
          >
        </div>

        <div class="col-12">
          <button
            class="btn btn-success"
            type="button"
            id="approvePowToken"
            :disabled="stakersPowAllowanceForLeveling > 0"
            @click="approvePowToken"
          >
            approve
          </button>
          &nbsp;
          <button
            class="btn btn-danger"
            type="button"
            id="removePowAllowance"
            :disabled="stakersPowAllowanceForLeveling <= 0"
            @click="removePowTokenAllowance"
          >
            (remove approval)
          </button>
        </div> 
      </div> 
    </div> -->
  </section>

  <div class="popup" v-if="feedbackMessage != '' || txInProgress">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 class="text-monospace animate-popup" v-if="feedbackMessage != ''">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h4 class="text-monospace animate-popup" v-if="txInProgress">
      Please wait for the transaction to finish!
    </h4>
  </div>
</template>

<script>
import { ethers } from "ethers";
import Reaperville from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";

export default {
  name: "App",
  components: {},

  data() {
    return {
      provider: null,
      signer: null,

      ETH: window.ETH,

      stakersAddress: "",
      stakersBchBalance: 0,

      feedbackMessage: "",
      txInProgress: false,
      lastTimeout: 0,

      mintContract: null,
      mintContractAddress: window.ca["reaper"],
      mintPaused: true,
      nftsToMint: 10,
      maxNftsPerTx: 40,
      bchPerNft: 20000000000000000,
      nftsMinted: 0,
      nftsOwned: 0,
      nftsToMintTotal: 2500,
      gasLimit: 250000,

      // stakersRewardTokenBalance: 0,

      // rewardTokenPerNft: 0,
      // flexUsdPerNft: 0,

      // contracts: null,
    };
  },
  methods: {
    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    getBchBalance: function () {
      this.provider.getBalance(this.stakersAddress).then((balance) => {
        this.stakersBchBalance = balance;
      });
    },

    setNftsToMint: function (_amount) {
      this.feedbackMessage = "";
      this.nftsToMint = Math.floor(_amount);
      if (this.nftsToMint < 1) {
        this.nftsToMint = 1;
      } else if (this.nftsToMint > this.maxNftsPerTx) {
        this.nftsToMint = this.maxNftsPerTx;
      }
    },

    changeNftsToMint: function (_changeAmount) {
      this.feedbackMessage = "";
      this.nftsToMint = Math.floor(this.nftsToMint) + _changeAmount;
      if (this.nftsToMint < 1) {
        this.nftsToMint = 1;
      } else if (this.nftsToMint > this.maxNftsPerTx) {
        this.nftsToMint = this.maxNftsPerTx;
      }
    },

    mintNFTsWithBCH: async function () {
      await this.load(); // get most recent values

      // check if there are enough NFTs left to mint as the user wants
      let nftsLeft = this.nftsToMintTotal - this.nftsMinted;
      if (this.nftsToMint > nftsLeft) {
        this.feedbackMessage = `There are only ${nftsLeft} NFTs available for minting!`;
        this.maxNftsPerTx = nftsLeft;
        return false;
      }

      // check if the user has enough funds
      let totalCostBchWei = this.bchPerNft * this.nftsToMint;
      let totalGasLimit = Math.min(
        10000000,
        this.gasLimit + (this.gasLimit - 25000) * (this.nftsToMint - 1)
      );

      console.log("totalCostBchWei: ", totalCostBchWei);
      console.log("Gas limit: ", totalGasLimit);

      if (this.stakersBchBalance < totalCostBchWei + totalGasLimit) {
        this.feedbackMessage = `You have ${
          Math.round(this.stakersBchBalance / 10 ** 14) / 10 ** 4
        } {{ ETH }} in your wallet. You can mint up to ${Math.round(
          this.stakersBchBalance / Number(this.bchPerNft) - 0.5
        )} NFTs with that.`;
        return false;
      }

      // mint NFTs
      this.feedbackMessage = `Minting your NFTs.`;
      this.txInProgress = true;

      let tx;
      try {
        tx = await this.mintContract.mint(this.nftsToMint, {
          value: totalCostBchWei.toString(),
          gasLimit: totalGasLimit.toString(),
        });
        // gasPrice: 1046740000,
        console.log(tx);
        await tx.wait();
        console.log(tx);
      } catch (err) {
        this.setFeedback("An error occured. Please try again later.", 2000);
        this.txInProgress = false;
        return false;
      }

      console.log("tx hash:", tx.hash);
      const txInfo = await this.provider.getTransaction(tx.hash);
      try {
        let code = await this.provider.call(txInfo, txInfo.blockNumber);
        console.log(code);
        if (code == "0x") {
          this.setFeedback(
            `Congratulations! You successfully minted some NFTs! Visit the staking website to take a look at your NFTs.`,
            2000
          );
          this.txInProgress = false;
        }
      } catch (err) {
        this.setFeedback("An error occured.\nPlease try again later.", 2000);
        this.txInProgress = false;
        const code = err.data.replace("Reverted ", "");
        console.log({ err });
        let reason = ethers.utils.toUtf8String("0x" + code.substr(138));
        console.log("revert reason:", reason);
      }

      this.load();
    },

    load: async function () {
      this.signer.getAddress().then((myAddress) => {
        this.stakersAddress = myAddress;
        this.getBchBalance();
        // this.getRewardTokenBalance();
        // this.getFlexUsdBalance();
        this.mintContract.balanceOf(myAddress).then((_nftsOwned) => {
          this.nftsOwned = _nftsOwned;
        });
      });
      this.mintContract.isMintPausedStakingPaused().then((result) => {
        this.mintPaused = result[0];
      });
      this.mintContract.bchPerNft().then((_bchPerNft) => {
        this.bchPerNft = _bchPerNft;
      });
      this.mintContract.totalSupply().then((_nftsMinted) => {
        this.nftsMinted = _nftsMinted;
      });
    },
  },
  mounted: function () {
    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();

        this.mintContract = new ethers.Contract(
          window.ca["reaper"],
          Reaperville.abi,
          this.signer
        );
      })
      .then(() => {
        this.load();
      });
  },
};
</script>
